module.exports = __webpack_public_path__ + "img/glazing_simple.6af7c70.svg";